import { render, staticRenderFns } from "./SimpleNav.vue?vue&type=template&id=4c70385a&scoped=true&"
import script from "./SimpleNav.vue?vue&type=script&lang=js&"
export * from "./SimpleNav.vue?vue&type=script&lang=js&"
import style0 from "./SimpleNav.vue?vue&type=style&index=0&id=4c70385a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70385a",
  null
  
)

export default component.exports